import { getDataMapper, mapField, getObjectId } from "@/shared";

export const mapRepairFiltersToServer = getDataMapper({
    employee_id: mapField("employee", getObjectId),
    inventory_id: mapField("inventory", getObjectId),
    outer_inventory: mapField("outerInventory", Boolean),
    repair_state_id: mapField("repairStatuses", getObjectId),
});
